import { gql } from 'graphql-tag';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { usePersistedQuery } from 'hooks/usePersistedQuery';
import { AppContext } from 'shared/AppContext';

export const GET_WEATHER_CENTER = gql`
  query GetWeatherCenter($input: Int, $track_id: Int) {
    getWeatherCenter(account_id: $input, track_id: $track_id) {
      location {
        lat
        lng
        timezone
        name
        city
        state
        source
      }
      conditions {
        tempF
        feelsLikeF
        description
        icon
        humidity
        dewPointF
        pressureIn
        windMph
        windDir
        gustMph
        visibilityMi
        cloudCoverPct
        uvIndex
        highF
        lowF
        sunrise
        sunset
      }
      precip {
        currentRateInHr
        last24In
        next24In
        nextRainAt
      }
      forecast {
        day
        date
        dateISO
        icon
        highF
        lowF
        precipPct
        rainIn
        windMph
        windDir
        summary
        hourly {
          time
          timeISO
          icon
          tempF
          precipPct
          rainIn
          windMph
          humidity
        }
      }
      lightning {
        status
        nearestMi
        sinceLastMin
        count
        bearing
      }
      stormCells {
        type
        severity
        motion
        distanceMi
        bearing
        etaMinutes
        maxHailIn
        maxWindMph
        lat
        lng
      }
      alerts {
        type
        severity
        county
        body
        issued
        effective
        expires
      }
      updatedAt
    }
  }
`;

// Polls every 60s; the fast cache tier on the backend keeps most polls cheap.
// On a /weather/:trackId route (the event tables' weather links) the exact
// track is targeted instead of the account's next venue.
export function useGetWeatherCenter() {
  const {
    state: { accountId },
  } = useContext(AppContext);
  const { trackId } = useParams();

  const track_id = trackId ? Number(trackId) : undefined;

  return usePersistedQuery(
    GET_WEATHER_CENTER,
    `weather-center-${accountId}-${track_id || 'account'}`,
    {
      variables: { input: accountId, track_id },
      pollInterval: 60000,
      fetchPolicy: 'cache-and-network',
    }
  );
}
